module.exports = __webpack_public_path__ + "img/ch13_11_古镇直播自拍.c4dee1ae.jpg";